import { InfoCircleOutlined } from '@ant-design/icons';
import { templateVariables } from '_/constants/common';
import useToggleValue from '_/hooks/useToggleValue';
import { COLORS } from '_/lib/frontend-utils';
import { Button, Popover } from 'antd';
import React, { ReactElement } from 'react';

import classes from './DestinationFormPopover.module.css';

const outlinedStyle = { color: COLORS.DARK_BLUE };

const popoverContent = templateVariables('s3');

const DestinationFormPopover = (): ReactElement => {
  const [value, toggleValue] = useToggleValue();

  return (
    <Popover
      open={value}
      onOpenChange={toggleValue}
      content={<div className={classes.typography}>{popoverContent}</div>}
      placement="right"
    >
      <Button type="text" shape="circle" onClick={toggleValue} icon={<InfoCircleOutlined style={outlinedStyle} />} />
    </Popover>
  );
};

export default DestinationFormPopover;
